import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Build-time defaults so the UI never renders blank if /api/site/assets is slow.
const DEFAULTS = {
    brand_logo: "/images/healthfairx_logo.png",
    landing_hero: "https://static.prod-images.emergentagent.com/jobs/c9c4766c-63a5-4366-8782-65f7fd9b3a60/images/8d9a1ef14f4b52dafae9183647fa76c022de3255f2f1126ca6ffa5b449ecdb5e.png",
    landing_about: "https://images.pexels.com/photos/8546652/pexels-photo-8546652.jpeg",
    landing_abstract: "https://static.prod-images.emergentagent.com/jobs/c9c4766c-63a5-4366-8782-65f7fd9b3a60/images/c0a08cccc209959282d3c4da1d816783b258f1b3072431ca6a59eec9f5c2f20a.png",
    howitworks_hero: "https://images.pexels.com/photos/3825586/pexels-photo-3825586.jpeg",
    login_background: "https://static.prod-images.emergentagent.com/jobs/c9c4766c-63a5-4366-8782-65f7fd9b3a60/images/c0a08cccc209959282d3c4da1d816783b258f1b3072431ca6a59eec9f5c2f20a.png",
    register_background: "https://images.pexels.com/photos/8546652/pexels-photo-8546652.jpeg",
};

// One in-flight fetch, shared across components.
let cache = null;
let inFlight = null;
const listeners = new Set();

const load = async () => {
    if (cache) return cache;
    if (inFlight) return inFlight;
    inFlight = api.get("/site/assets")
        .then((res) => {
            cache = { ...DEFAULTS, ...(res.data || {}) };
            listeners.forEach((fn) => fn(cache));
            return cache;
        })
        .catch(() => {
            cache = { ...DEFAULTS };
            listeners.forEach((fn) => fn(cache));
            return cache;
        })
        .finally(() => { inFlight = null; });
    return inFlight;
};

export const useSiteAssets = () => {
    const [assets, setAssets] = useState(cache || DEFAULTS);
    useEffect(() => {
        let mounted = true;
        const onUpdate = (next) => { if (mounted) setAssets(next); };
        listeners.add(onUpdate);
        load();
        return () => { mounted = false; listeners.delete(onUpdate); };
    }, []);
    return assets;
};

// Used by the admin tab to refresh the cache + broadcast after a save.
export const refreshSiteAssets = async () => {
    cache = null;
    await load();
};
